// Several components mount together (header, desktop sidebar, the header's mobile-menu sidebar, the breadcrumb's
// mobile sidebar) and each asked for the same store data on mount, so a page load sent profile/me 3x,
// side-menu/web 2x and plans/cart/detail 2x. They all read the result from Vuex, so one request is enough:
// calls with the same key within `ms` of the first are skipped.
const lastRun = {};

export function loadOnce(key, fn, ms = 3000) {
  const now = Date.now();
  if (lastRun[key] && now - lastRun[key] < ms) return;
  lastRun[key] = now;
  return fn();
}
